import React from 'react'
import styled from 'react-emotion'
import withQueryParams from 'components/withQueryParams'
import { findPlatform } from 'config/platforms'
import { Loader } from 'stylist'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const RouteRedirecting = ({ query }) => {
  const platform = findPlatform(query.get('platformId'))

  return (
    <Container>
      <h5>You are being redirected {platform && `to ${platform.title}`}</h5>
      <Loader />
    </Container>
  )
}

export default withQueryParams(RouteRedirecting)



// WEBPACK FOOTER //
// ./src/routes/login/redirecting.js